import "./IT.css"

function IT() {
     return (  
        <section id="it">
            <div className="sectionBox">
                <div className="it">
                    <nav className="#it">
                        <h1>
                            IT Consultancy Services
                        </h1>
                        <p>
                            Offering consultancy services, guidance and support for IT including:
                        </p>
                        <ul>
                            <li>Digital Transformation</li>
                            <li>Software Development</li>
                            <li>System Integration</li>
                            <li>Data Analytics and Business Intelligence</li>
                            <li>Web Development</li>
                        </ul>
                    </nav>
                </div>
            </div>
        </section>
    );
}

export default IT